import http from "common/http";

export function verifyUserToken(url) {
  return http.get(url, {
    params: { _t: new Date().getTime() },
    credentials: "same-origin",
  });
}

export function getFeatures(url) {
  return http.get(url, {
    headers: {
      "X-CSRF-Token": null,
    },
  });
}
